<!-- ----------------------------------------------- -->
<template>
  <v-col class="detail-col" no-gutters>
    <div class="detail-frame-scroll">
      <!-- 河川予警報カード -->
      <div
        v-if="
          isDispRw(itmkndCd) &&
            obsDispStatusRiverWarnInfo &&
            tmRwInfo &&
            tmRwInfo.length > 0
        "
      >
        <tm-detail-rw></tm-detail-rw>
      </div>

      <!-- 観測所お知らせカード -->
      <div
        v-if="isDispInfo(itmkndCd) && obsDispStatusInfo && tmInfo.length > 0"
      >
        <tm-detail-info></tm-detail-info>
      </div>

      <div class="mt-2">
        <v-card class="com-pc-card">
          <tm-rain-detail-frame v-if="itmkndCd === '1'"></tm-rain-detail-frame>
          <tm-bsn-detail-frame v-if="itmkndCd === '2'"></tm-bsn-detail-frame>
          <tm-snow-detail-frame v-if="itmkndCd === '3'"></tm-snow-detail-frame>
          <tm-stage-detail-frame
            v-if="itmkndCd === '4'"
          ></tm-stage-detail-frame>
          <tm-wtr-qual-detail-frame
            v-if="itmkndCd === '6'"
          ></tm-wtr-qual-detail-frame>
          <tm-dam-detail-frame v-if="itmkndCd === '7'"></tm-dam-detail-frame>
          <tm-coast-detail-frame
            v-if="itmkndCd === '12'"
          ></tm-coast-detail-frame>
          <tm-rd-bsn-detail-frame
            v-if="itmkndCd === '20'"
          ></tm-rd-bsn-detail-frame>
          <tm-sw-stage-detail-frame
            v-if="itmkndCd === '300'"
          ></tm-sw-stage-detail-frame>
        </v-card>
      </div>
    </div>
  </v-col>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 [PC]観測所詳細画面
 * TmDetail.vue
 * @author ILUKE
 */

/** 観測所お知らせカード */
import TmDetailInfo from "../../components/pc/full/TmInfo.vue";
/** 河川予警報カード */
import TmDetailRw from "../../components/pc/full/TmDetailRw.vue";
/** 個別観測所詳細カード */
import TmStageDetailFrame from "../../components/pc/full/TmStageDetailFrame.vue";
import TmRainDetailFrame from "../../components/pc/full/TmRainDetailFrame.vue";
import TmDamDetailFrame from "../../components/pc/full/TmDamDetailFrame.vue";
import TmWtrQualDetailFrame from "../../components/pc/full/TmWtrQualDetailFrame.vue";
import TmSnowDetailFrame from "../../components/pc/full/TmSnowDetailFrame.vue";
import TmCoastDetailFrame from "../../components/pc/full/TmCoastDetailFrame.vue";
import TmRdBsnDetailFrame from "../../components/pc/full/TmRdBsnDetailFrame.vue";
import TmBsnDetailFrame from "../../components/pc/full/TmBsnDetailFrame.vue";
import TmSwStageDetailFrame from "../../components/pc/full/TmSwStageDetailFrame.vue";

export default {
  data() {
    return {};
  },
  components: {
    TmDetailInfo,
    TmDetailRw,
    TmStageDetailFrame,
    TmRainDetailFrame,
    TmDamDetailFrame,
    TmWtrQualDetailFrame,
    TmSnowDetailFrame,
    TmCoastDetailFrame,
    TmRdBsnDetailFrame,
    TmBsnDetailFrame,
    TmSwStageDetailFrame,
  },
  created: function() {
    if (this.$route.query.itmkndCd == "300") {
      /** 危機管理水位計の場合 */
      /** 選択中テレメータ情報を設定 */
      this.$store.commit("Swin/setSelectedSwParam", {
        swofcCd: this.$route.query.ofcCd,
        itmkndCd: this.$route.query.itmkndCd,
        swobsCd: this.$route.query.obsCd,
      });

      /** グラフ切替ボタン 初期値 設定 */
      this.$store.commit("Telemeter/resetTmObs");
    } else {
      /** 選択中テレメータ情報を設定 */
      this.$store.commit("Telemeter/setSelectedTmParam", {
        ofcCd: this.$route.query.ofcCd,
        itmkndCd: this.$route.query.itmkndCd,
        obsCd: this.$route.query.obsCd,
      });

      /** グラフ切替ボタン 初期値 設定 */
      this.$store.commit("Telemeter/resetTmObs");
    }
    // 河川予警報情報を取得
    this.getRiverWarnInfo();
  },
  computed: {
    itmkndCd: {
      get() {
        return String(this.$route.query.itmkndCd);
      },
    },
    /**
     * 河川予警報情報件数 取得
     */
    tmRwInfo: {
      get() {
        return this.$store.state.map.riverWarnInfo;
      },
    },
    /**
     * お知らせ情報件数 取得
     */
    tmInfo: {
      get() {
        return this.$store.state.map.information;
      },
    },
    /** コンテンツ切替(河川予警報) */
    obsDispStatusRiverWarnInfo: {
      get() {
        return this.$store.state.Telemeter.obsDispStatus.riverWarnInfo;
      },
    },
    /** コンテンツ切替(お知らせ) */
    obsDispStatusInfo: {
      get() {
        return this.$store.state.Telemeter.obsDispStatus.info;
      },
    },
  },
  methods: {
    /** 河川予警報 表示判定 */
    isDispRw(itmkndCd) {
      // 水位とダムは河川予警報を表示する。
      if (itmkndCd == "4" || itmkndCd == "7") {
        return true;
      }
      return false;
    },
    /** お知らせ 表示判定 */
    isDispInfo(itmkndCd) {
      // 危機管理水位は表示しない
      if (itmkndCd == "300") {
        return false;
      }
      return true;
    },
    /**
     * 河川予警報情報を取得
     */
    getRiverWarnInfo() {
      this.$store.dispatch("map/getObsRiverWarnInfo", {
        ofcCd: this.$store.state.Telemeter.selectedTmParam.ofcCd,
        itmkndCd: this.$store.state.Telemeter.selectedTmParam.itmkndCd,
        obsCd: this.$store.state.Telemeter.selectedTmParam.obsCd,
        isFldCtl: this.$store.getters["app/isFldCtl"],
        appTime: this.$store.state.app.appTimeRound,
      });
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped>
.detail-col {
  // 縦並べ
  display: flex;
  flex-direction: column;
  height: 100%;

  .detail-frame-scroll {
    overflow-y: auto;
    overflow-x: hidden;
    flex-grow: 1;
    flex-basis: 0;
  }
}
</style>
